import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubLogDetails from './Subcomponents/LogDetails';
import withRouter from './Functions/WithRouter';

class AdvLogDetails extends Component {
    constructor(props) {
      super(props)

      this.state = {

      }
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let username = localStorage.getItem('username');
      let cuFirstName = localStorage.getItem('firstName');
      let cuLastName = localStorage.getItem('lastName');
      let activeOrg = localStorage.getItem('activeOrg');
      let orgFocus = localStorage.getItem('orgFocus');
      const orgLogo = localStorage.getItem('orgLogo');

      const { logDetails, advisee } = this.props.location.state;
      console.log('show me logDetails ', logDetails, advisee)

      this.setState({ email, username, cuFirstName, cuLastName, activeOrg, orgLogo,
        logDetails, advisee, member: advisee, orgFocus, roleName
      })
    }

    render() {


      return (
        <div>
          <AppNavigation username={this.state.username} fromAdvisor={true} activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus} roleName={this.state.roleName} history={this.props.navigate} />
          <SubLogDetails activeOrg={this.state.activeOrg} logDetails={this.state.logDetails} member={this.state.member} />

          {(this.state.activeOrg) && (
            <div>
              {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
            </div>
          )}
        </div>
      )
    }
}

export default withRouter(AdvLogDetails);
